// DATE formatting function utilities

export function searchObjInArray(searchString, searchKey, theArray) {
  for (let i = 0; i < theArray.length; i++) {
    if (theArray[i][searchKey] === searchString) {
      return theArray[i];
    }
  }

  return null;
}
